import apiClient from '../api/api';

export interface TableCount {
  table: string;
  devCount: number;
  prodCount: number;
}

export interface SchemaValidation {
  isValid: boolean;
  errors: string[];
  devMigrations: string[];
  prodMigrations: string[];
}

export interface MigrationStatus {
  enabled: boolean;
  devLocked: boolean;
  isRunning: boolean;
  lastOperation?: string;
  lastMessage?: string;
  lastFinishedAt?: string;
  schema?: SchemaValidation;
  tableCounts: TableCount[];
}

export interface OperationResult {
  operation: string;
  success: boolean;
  message: string;
  tables: { table: string; rowsAffected: number }[];
}

interface ApiEnvelope<T> {
  status: number;
  data: T;
}

const getEnvelope = async <T>(url: string): Promise<ApiEnvelope<T>> => {
  const { data } = await apiClient.get<ApiEnvelope<T>>(url);
  return data;
};

const postEnvelope = async <T>(url: string, body: object): Promise<ApiEnvelope<T>> => {
  const { data } = await apiClient.post<ApiEnvelope<T>>(url, body);
  return data;
};

export const dataMigrationService = {
  getStatus: () => getEnvelope<MigrationStatus>('/api/data-migration/status'),
  validateSchema: () => postEnvelope<SchemaValidation>('/api/data-migration/validate-schema', {}),
  cleanProd: (confirmationPhrase: string) =>
    postEnvelope<OperationResult>('/api/data-migration/clean-prod', { confirmationPhrase }),
  fullMigrate: (confirmationPhrase: string) =>
    postEnvelope<OperationResult>('/api/data-migration/full-migrate', { confirmationPhrase }),
  sync: (confirmationPhrase: string, includeAuditsInSync: boolean) =>
    postEnvelope<OperationResult>('/api/data-migration/sync', { confirmationPhrase, includeAuditsInSync }),
  cleanDev: (confirmationPhrase: string) =>
    postEnvelope<OperationResult>('/api/data-migration/clean-dev', { confirmationPhrase }),
};

export const isDataMigrationUiEnabled = (): boolean =>
  process.env.REACT_APP_ENABLE_DATA_MIGRATION === 'true';
